// Client-side add-on catalog (mirrors backend ADDON_CATALOG in cents).
// Backend is the source of truth for pricing/totals — this is used only for
// the interactive UI (toggles, preview totals before saving).

export const BASE_SETUP_CENTS = 149900;
export const BASE_MONTHLY_CENTS = 29900;

export const ADDONS = [
  {
    key: "additional_page",
    name: "Additional page",
    one_time: 24900,
    monthly: 0,
    bundle: { qty: 3, one_time: 59900 },
    note: "$249 each · 3 for $599",
  },
  {
    key: "online_booking",
    name: "Online booking / scheduling",
    one_time: 49900,
    monthly: 4900,
    note: "$499 setup + $49/mo",
  },
  {
    key: "online_payments",
    name: "Online payments / deposits",
    one_time: 49900,
    monthly: 0,
    note: "$499 setup",
  },
  {
    key: "content_writing",
    name: "Blog / content writing",
    one_time: 0,
    monthly: 34900,
    note: "$349/mo — 4 SEO posts",
    lead: true,
  },
  {
    key: "extra_location",
    name: "Extra location",
    one_time: 39900,
    monthly: 9900,
    note: "$399 setup + $99/mo per location",
  },
];

export function fmtMoney(cents) {
  const n = Number(cents || 0) / 100;
  return `$${n.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`;
}
